import React from "react";
import { RegisterOptions } from "react-hook-form";
import { FormItem, PasswordField } from "..";
import { PasswordControlProps } from "./PasswordControl.types";
import { GetChildrePropsParams } from "../FormItem/FormItem.types";

function PasswordControl(props: PasswordControlProps) {
  const {
    defaultValue,
    getPasswordFieldProps,
    hideHelperText,
    label,
    maxLength,
    name,
    required,
    validate,
    valuePropName,
    ...other
  } = props;

  const rules = React.useMemo<RegisterOptions>(() => {
    const result: RegisterOptions = {
      validate,
    };
    if (required) {
      result.required = {
        value: true,
        message: label ? `${label} is required` : "Required field",
      };
    }
    if (maxLength !== undefined) {
      result.maxLength = {
        value: maxLength,
        message: `The maximum number of characters is ${maxLength}`,
      };
    }
    return result;
  }, [label, required, validate, maxLength]);

  const getChildrenProps = React.useCallback(
    (params: GetChildrePropsParams) => {
      return getPasswordFieldProps?.(params);
    },
    [getPasswordFieldProps]
  );

  return (
    <FormItem
      defaultValue={defaultValue}
      getChildrenProps={getChildrenProps}
      hideHelperText={hideHelperText}
      name={name}
      rules={rules}
      valuePropName={valuePropName}
    >
      <PasswordField {...other} label={label} />
    </FormItem>
  );
}

export default React.memo(PasswordControl);
